import React, {useEffect, useState} from 'react';
import "../../css/dashboardStylings/DashboardJournalStyling.css";

const DashboardJournalComponent = () => {
    const [journalEntries, setJournalEntries] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchAllJournalEntries = async () => {
            try {
                setLoading(true);

                const journalResponse = await fetch('/api/journal/fetchJournalEntries');
                const journalResult = await journalResponse.json();

                if (!journalResponse.ok) {
                    console.error('Failed to load journal entries:', journalResult.error);
                    return;
                }

                setJournalEntries(journalResult.data);

            } catch (error) {
                console.error('Fetch error:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchAllJournalEntries();
    }, []); // Add dependency array

    if (loading) {
        return <div>Loading journal entries...</div>;
    }


    return (
        <div className={`journal-component-body`}>
            {journalEntries.slice(0, 5).map((journalEntry) => (
                <div className={`journal-entry-preview`} key={journalEntry.id}>
                    <div className={`journal-entry-preview-title-and-date`}>
                        <div className={`journal-entry-preview-title`}>
                            {journalEntry.title}
                        </div>
                        <div className={`journal-entry-preview-date`}>
                            {new Date(journalEntry.created_at).toLocaleString('en-US', {
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                            })}
                        </div>
                    </div>

                    <div className={`journal-entry-preview-content`}>
                        {journalEntry.content}
                    </div>
                </div>
            ))}

            {journalEntries.length > 0 ? (
                <div className={`click-to-view-all-button`}>
                    <div className={`click-to-view-all-text`}>View and edit your garden journals</div>
                </div>
            ) : (
                <div className="no-entries-message">
                    <div>No journal entries yet. Start your first garden journal!</div>
                    <button className="start-entry-button">Create Entry</button>
                </div>
            )}
        </div>
    );
};

export default DashboardJournalComponent;